export default __webpack_public_path__ + "static/media/openBacktick.205fd117.svg";